<template>
  <div>
    <BreadCrumb :data="breadCrumb" />
    <b-card>
      <div class="groups">
        
        <div class="buttons">
          <b-button :title="$t('general.add')" variant="primary" @click="openModal(true,'add')">{{$t('general.add')}}</b-button>
        </div>

        <b-form inline class="formBox"> 
          <div  class="inputGrp" >
            <b-table-simple hover responsive>
              <b-thead>
                <b-th>Sonuçlar</b-th>
                <b-th></b-th>
              </b-thead>
              <b-tbody>
                <b-tr v-for="item in faultSupportResults" :key="item.id">
                  <b-td> {{item.name}}</b-td>
                  <b-td> 
                    <div class="buttons">
                      <b-button size="sm" :title="$t('general.edit')" variant="success" @click="openModal(true,'edit',item)"> <b-icon icon="pen-fill" aria-hidden="true"></b-icon> </b-button>
                      <b-button size="sm" :title="$t('general.delete')" variant="danger" @click="openModal(true,'delete',item)"> <b-icon icon="trash" aria-hidden="true"></b-icon> </b-button>
                    </div>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-form>
      </div>
    </b-card>

    <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import i18n from "@/plugins/i18n";
import Modals from "./modals/";

let breadCrumb = [
  { label: i18n.t("pages.defination.name"), url: "/Defination" },
  { label: "Arıza Destek Sonuçları", url: "/Defination/FaultSupportResults" }
]

export default {
  name: "FaultSupportResults",
  components: { BreadCrumb, Modals },
  data: function () {
    return {
      breadCrumb,
      modalOpen: false,
      modalProps: {},
      currentForm: "FaultSupportResults",
      modalName: "",
    };
  },
  computed: {
    faultSupportResults() {
      return this.$store.getters.getFaultSupportResults
    }
  },
  methods: {
    openModal: function(state, modal, props){
      this.modalOpen = state;
      this.modalProps = props;
      this.modalName = modal;
    }
  },
  created() {
    this.$store.dispatch('listFaultSupportResults')
  }
};
</script>

<style lang="css" scoped > 
  @import "./styles/signalGroups.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Defination/FaultSupportResults.vue